import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { hasKey, } from '@tymia/shared';
import { memoize, } from 'micro-memoize';
import { useEffect, useState, } from 'react';
import { useForm, } from 'react-hook-form';
import { useParams, } from 'react-router-dom';
import logo from '../../../../src/pages/search/logo.png';
import { api, } from '../../../api/Api.js';
import { useTranslation, } from '../../../useTranslation.js';
import { Input, } from '../../components/Input.js';
// this API is sensitive too multiple calls,
// which are triggered by strict mode
const requestTan = memoize(api.client.invoice.requestTan.request, {
    async: true,
    isDeepEqual: true,
    maxAge: 1_000,
});
export function Download() {
    const token = useParams().token;
    const [state, setState] = useState();
    const [downloadState, setDownloadState] = useState();
    const tRoot = useTranslation();
    const t = tRoot.client.invoice.download;
    useEffect(() => {
        let isMounted = true;
        async function run() {
            if (!token) {
                return;
            }
            if (state === undefined) {
                const response = await requestTan({ token });
                if (isMounted) {
                    setState(response);
                }
            }
        }
        void run();
        return () => {
            isMounted = false;
        };
    }, [token, state]);
    const { register, handleSubmit, formState: { errors }, } = useForm({
        defaultValues: {
            token: token ?? '',
            tan: '',
        },
    });
    async function onSubmit(data) {
        const result = await api.client.invoice.download.request({ ...data, action: 'download' });
        setDownloadState(result);
        if (result.status === 'file') {
            const link = document.createElement('a');
            const url = URL.createObjectURL(result.file);
            link.href = url;
            link.download = result.fileName;
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        }
    }
    let title;
    let body;
    if (!token) {
        title = t.title.error;
        body = _jsx("div", { children: t.message.invalidToken });
    }
    else if (state?.status === 'ok' && hasKey(state, 'phone')) {
        title = t.title.enterTan;
        const tan = register('tan', { required: tRoot.common.error.isRequired });
        body = (_jsxs(_Fragment, { children: [_jsx("div", { children: t.message.enterTan(state.phone) }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "mt-4", children: [_jsx(Input, { id: "tan", label: t.input.tan.label, inputMode: "numeric", autoFocus: true, ...tan, error: errors.tan?.message ?? downloadState?.status === 'error' ? t.message.invalidTan : undefined }), _jsx("input", { type: "hidden", ...register('token') }), _jsx("button", { type: "submit", className: "w-full primary", children: t.input.submit.label })] })] }));
    }
    else if (state?.status === 'error' && state.reason === 'invalid phone number') {
        title = t.title.error;
        body = _jsx("div", { children: t.message.notMobile });
    }
    else if (state?.status === 'error' && state.reason === 'rate limited') {
        title = t.title.error;
        body = _jsx("div", { children: t.message.rateLimited });
    }
    else if (state?.status === 'error' && state.reason === 'too many tans requested') {
        title = t.title.error;
        body = _jsx("div", { children: t.message.tooManyTansRequested });
    }
    else if (state?.status === 'error' && state.reason === 'invalid token') {
        title = t.title.error;
        body = _jsx("div", { children: t.message.invalidToken });
    }
    else if (state?.status === 'network error') {
        title = t.title.error;
        body = _jsx("div", { children: tRoot.common.error.network });
    }
    else {
        console.error('unexpected state', state);
    }
    return (_jsxs("div", { className: "h-screen", children: [_jsx("title", { children: t.metaTitle }), _jsx("div", { className: "absolute top-4 left-4", children: _jsx("img", { src: logo, alt: "Tymia Logo", className: "h-12 w-auto" }) }), _jsx("div", { className: "flex h-full justify-center items-center", children: _jsxs("div", { className: "m-3", children: [_jsx("h3", { className: "font-medium", children: title }), body] }) })] }));
}
//# sourceMappingURL=Download.js.map